import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import registerServiceWorker from './registerServiceWorker';
import { setupCognito, cognito } from 'react-cognito';

import candidateProfileReducer from "./store/reducers/candidateProfile";
import talentPoolReducer from "./store/reducers/talentPool";
import candidateReviewReducer from "./store/reducers/candidateReview";
import clientProfile from './store/reducers/clientProfile';
import { watchCandidateProfile, watchTalentPool, watchGroupTalentPool, watchClientDetails } from "./store/sagas";

import './index.css';
import App from './App';
import config from './config.js';

const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : 
    null || compose;

/**
 * @desc Combine Multiple reducers
 * @param null
 * @return null
 */
const rootReducer = combineReducers({
  cognito: cognito,
  candidateProfile: candidateProfileReducer,
  talentPool: talentPoolReducer,
  groupTalentPool: candidateReviewReducer,
  clientProfile: clientProfile
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, sagaMiddleware))
);

sagaMiddleware.run(watchCandidateProfile);
sagaMiddleware.run(watchTalentPool);
sagaMiddleware.run(watchGroupTalentPool);
sagaMiddleware.run(watchClientDetails);

setupCognito(store, config.cognito);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js